import axios from 'services/api';
import { API2_HOST } from '../../helpers/urlHelper';
import { ApiResponse } from '../../helpers/stockLocationHelpers';

axios.defaults.withCredentials = true;

const actionPlanBaseURL = `${API2_HOST}/sc-action-plans`;
const subTaskBaseURL = `${API2_HOST}/sc-action-plan-sub-tasks`;

const sendSubTaskRequest = async requestConfig => {
  const result = new ApiResponse();
  try {
    const res = await axios(requestConfig);
    if (res.status !== 200) return result;

    result.success = res.data?.success;
    result.data = res.data?.data;
    result.message = res.data?.message;
    return result;
  } catch (error) {
    console.log('ERROR: ', { ...error });
    return result;
  }
};

const getActionPlanSubTasks = actionPlanId =>
  sendSubTaskRequest({
    method: 'get',
    url: `${actionPlanBaseURL}/${actionPlanId}/sub-tasks`
  });

const createActionPlanSubTask = (actionPlanId, subTask) =>
  sendSubTaskRequest({
    method: 'post',
    url: `${actionPlanBaseURL}/${actionPlanId}/sub-tasks`,
    data: { ...subTask }
  });

const patchActionPlanSubTask = (subTaskId, changedFields) =>
  sendSubTaskRequest({
    method: 'patch',
    url: `${subTaskBaseURL}/${subTaskId}`,
    data: { ...changedFields }
  });

const deleteActionPlanSubTask = subTaskId =>
  sendSubTaskRequest({
    method: 'delete',
    url: `${subTaskBaseURL}/${subTaskId}`
  });

export {
  getActionPlanSubTasks,
  createActionPlanSubTask,
  patchActionPlanSubTask,
  deleteActionPlanSubTask
};
